import { useState } from "react";
import {
  Box,
  DataGrid,
  FormControlLabel,
  Grid,
  Switch,
  Tooltip,
  Typography,
} from "../../../components";
import { formatPrice } from "../../../utils";

const TitulosGrid = ({ titulos, colunas }) => {
  const [somenteComErro, setSomenteComErro] = useState(false);
  const titulosComErro = titulos.filter(
    (titulo) => Object.keys(titulo.erros).length,
  );
  const valorTotal = titulos.reduce(
    (total, titulo) => total + (titulo.valorTotal || 0),
    0,
  );

  const renderCelula = (params) => {
    const erro = params.row.erros[params.field];
    if (!erro) return params.formattedValue;
    return (
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Tooltip title={erro} arrow placement="top">
          <i
            className="ph ph-warning"
            style={{ fontSize: 22, color: "#e53935" }}
          />
        </Tooltip>
        {params.formattedValue}
      </Box>
    );
  };

  return (
    <Grid container spacing={2} sx={{ pl: 2, mt: 1 }}>
      <Grid item xs={12} sx={{ display: "flex", alignItems: "center", gap: 4 }}>
        <Typography>Títulos: {titulos.length}</Typography>
        <Typography>Valor Total: {formatPrice(valorTotal)}</Typography>
        <Typography color={titulosComErro.length ? "error" : "inherit"}>
          Com erro: {titulosComErro.length}
        </Typography>
        <FormControlLabel
          control={
            <Switch
              checked={somenteComErro}
              onChange={() => setSomenteComErro(!somenteComErro)}
              color="primary"
            />
          }
          label="Mostrar só títulos com erro"
        />
      </Grid>
      <Grid item xs={12}>
        <DataGrid
          rows={somenteComErro ? titulosComErro : titulos}
          columns={colunas.map((coluna) => ({
            ...coluna,
            renderCell: renderCelula,
          }))}
          disableAcoes
        />
      </Grid>
    </Grid>
  );
};

export default TitulosGrid;
